import React, { useMemo } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import GamesTabContent from "../../components/games-tab/GamesTabContent/GamesTabContent";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../utils/renderHeaders";

import useGameDetailsBySlugQuery from "../../react-query/queries/use-game-details-by-slug";
import { getCurrentOrigin } from "../../utils/helpers";

function GamesPage() {
  const { slug } = useParams();
  const [queryParams] = useSearchParams();
  const gameQuery = queryParams.get("g");
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const { data: gameDataFromSlug } = useGameDetailsBySlugQuery({
    slug: slug ?? "",
  });

  const pageTitles = useMemo(() => {
    const title = t("metadata:sigma_games_title");
    const ogTitle = extractOgTitleFromMainTitle(title);
    return { title, ogTitle };
  }, [t]);

  const description = useMemo(() => {
    return t("metadata:sigma_games_description");
  }, [t]);

  const canonicalUrl = useMemo(() => {
    const origin = getCurrentOrigin();
    return gameQuery ? `${origin}/games/${gameQuery}` : `${origin}${pathname}`;
  }, [gameQuery, pathname]);

  const pageHeaders = renderHeaders({
    title: pageTitles.title,
    description,
    ogTitle: pageTitles.ogTitle,
    image: gameDataFromSlug?.poster,
    canonicalUrl,
  });

  return (
    <>
      {pageHeaders}
      <GamesTabContent />
    </>
  );
}

export default GamesPage;
